import { useEffect, useMemo, useState } from "react";

const Stepper = (props) => {
  const { disabled, onChange, label, id } = props || {};
  const item = useMemo(() => (props || {}).item || { amount: 0 }, [props]);
  const [amount, setAmount] = useState(item.amount);

  useEffect(() => {
    if (item) {
      setAmount(item.amount);
    }
  }, [item, item.amount]);

  const updateValue = (value) => {
    let oldValue = amount;
    setAmount(value);
    if (typeof onChange === "function") {
      if (onChange(value) === false) setAmount(oldValue);
    }
  };

  const handleClickDecrement = () => {
    if (disabled) return;
    updateValue(Math.max(1, amount - 1));
  };

  const handleClickIncrement = () => {
    if (disabled) return;
    updateValue(amount + 1);
  };

  const handleInputAmount = (e) => {
    if (!e || !e.target || e.target.value === "") {
      setAmount("");
      return;
    }
    const value = Number(e.target.value);
    if (value > 0) {
      updateValue(value);
    }
  };

  const handleBlur = () => {
    if (!amount > 0) {
      setAmount(item ? item.amount : 0);
    }
  };

  return (
    <div className="ser-stepper ser-iblock">
      <button type="button"
        onClick={handleClickDecrement}
        className="ser-stepdown"
        aria-label="-1"
      >
        {" "}
      </button>
      <input
        id={id}
        type="text"
        className="ser-input test"
        value={amount}
        onChange={handleInputAmount}
        onBlur={handleBlur}
        disabled={disabled}
        pattern="[0-9]*"
        aria-label={label}
      />
      <button type="button"
        onClick={handleClickIncrement}
        className="ser-stepup"
        aria-label="+1"
      >
        {" "}
      </button>
    </div>
  );
};

export default Stepper;
